// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-565e2f55] {\n  color: red;\n}\n.user-form .el-form-item.email .el-input__inner[data-v-565e2f55] {\n  width: 20em;\n}\n.user-form .el-form-item.role-id .el-input__inner[data-v-565e2f55] {\n  width: 20em;\n}", ""]);
// Exports
module.exports = exports;
